import SearchbarComponent from "components/v2/Listings/SearchBarComponent";
import SearchBarStyle from "components/v2/Listings/SearchBarComponent/SearchBar.module.scss";
import { useRouter } from "next/router";
import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import { decrypt, encrypt } from "utils/CRYPTO/secret";

import Pagination from "components/v2/Annuaire/Pagination";
import ListingsListComponent from "components/v2/Listings/ListingsListComponent";
import ListingsRouterUrlHelper, {
  buildListingUrl,
  buildUrl,
} from "components/v2/Listings/ListingsRouterUrlHelper";
import ListingsSortAndMapSwitch, {
  MIN_ZOOM_TO_DISPLAY_POPUP,
} from "components/v2/Listings/SearchBarComponent/components/ListingsSortAndMapSwitch";

import PROXY_CONFIG, { PROXY_CONFIG_V3 } from "Config/ProxyConfig";
import { MapRef } from "react-map-gl";
import { useDispatch, useSelector } from "react-redux";
import { selectors as AuthreducerSelectors } from "../../../redux/slices/authReducer";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "../../../redux/slices/v2/ListingReducer";
import { RootState } from "../../../types/RootState";

import dynamic from "next/dynamic";
import ListingDiscoveryCss from "./ListingDiscovery.module.css";
// import ListingsMapComponent from "components/v2/Listings/ListingsMapComponent";
import useTranslation from "next-translate/useTranslation";
import debounce_custom from "utils/Debounce";
// import { init } from "next/dist/compiled/@vercel/og/satori";
import { PAGE_SIZE } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import switch_map_language from "utils/MapBoxRTL/SwitchLanguage";
// import Footer from "components/v3/common/footer/Footer";
import Footer from "../../../SanityComponents/Footer/Footer";

import ListingsPageTitle from "components/v2/Listings/ListingsPageTitle";
import SideBarAnnonce from "./SideBarAnnonce";
export const ZOOM_TRANSITION_MAP_API = 11.5;
export const ZOOM_TRANSITION_MAP_API_DRAG = 10;

import createImageUrlBuilder from "@sanity/image-url";
import Navbar from "components/navbar/Navbar";
import ListingsSubList from "components/v2/Listings/ListingsSubList";
import { createClient } from "next-sanity";
import { selectors as ListingsReducerSelectors } from "../../../redux/slices/v2/ListingReducer";

import Redirect404 from "components/Error404/Annonces404/Redirect404";
import SearchNavbar from "components/v2/Listings/SearchBarComponent/SearchNavbar";
import PlacesAutoCompleteInput from "components/v2/Listings/SearchBarComponent/components/PlacesAutoComplete";
import nookies from "nookies";
import {
  setAuthenticated,
  setEmail,
  setUID,
  setUser as setUserDispatch,
  signInR,
  updateUser,
} from "redux/slices/authReducer";
import { checkUserClientSide } from "utils/BackendHelper";
import { titleSuffix } from "utils/BuildUrl/buildTitleAnnonce";
import {
  actions as UserSpaceActions,
  selectors as UserSpaceSelectors,
} from "../../../redux/slices/v2/UserSpace";

import FillDariane from "components/v2/Listings/FillDariane";
import ListingsResultAndSort from "../../../components/v2/Listings/ListingsResultAndSort";
import sanityFooter from "./footer.json";
import $ from "utils/selectors";
import ExcluCard from "./SideBarAnnonce/ExcluCard";
import { fix_type } from "pagesHelpers/ListingPagesHepler/ListingPagesHelperWrapper";
import ArticleInsideListingList from "components/v2/Listings/ArticleInsideListingList";
import { set_size } from "utils/getImageToDisplay";
import { debounce } from "lodash";
import { VscDebugBreakpointConditionalUnverified } from "react-icons/vsc";
const SortDialog = dynamic(
  () =>
    import("components/v2/Listings/SearchBarComponent/components/SortDialog"),
  {
    suspense: false,
    ssr: false,
  }
);

const LoginRegisterDialog = dynamic(
  () => import("components/LoginRegisterDialog"),
  {
    suspense: false,
    ssr: false,
  }
);
const ListingsMapComponent = dynamic(
  () => import("components/v2/Listings/ListingsMapComponent"),
  {
    ssr: false,
    suspense: false,
  }
);

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});

function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

type ListingDiscoveryContainerProps = {
  region?: string;
  province?: string;
  commune?: string;
  title?: string;
  initialListings?: any;
  h1Type?: any;
  RegionProvinceCommune?: {
    region?: string;
    province?: string;
    commune?: string;
  };
  viewType: "Vente" | "Location" | "Projets Neufs" | "";
  defaultBienType?: any;
  totalItems: number;
  isError?: boolean;
  articleData?: any;
};

export default function ListingDiscoveryContainer({
  region,
  province,
  commune,
  viewType,
  initialListings,
  RegionProvinceCommune,
  defaultBienType,
  title,
  h1Type,
  totalItems,
  isError,
  articleData,
}: ListingDiscoveryContainerProps) {
  const dispatch = useDispatch();

  const mapRef = React.useRef<MapRef>(null);
  const firstUpdateRef = useRef(true);
  const mapVsListSlct = useSelector(ListingsReducerSelectors.mapVsListSelactor);
  const displayMobileSearchBar = useSelector(
    ListingsReducerSelectors.displayMobileSearchBarSelactor
  );
  const zoomStart = useRef(0);

  const [mapVsList, setMapVsList] = useState(mapVsListSlct);

  // useEffect(() => {
  //   if (firstUpdateRef.current) {
  //     return;
  //   } else if (window.cartedesannonces) {
  //     firstUpdateRef.current = false;
  //     if (mapVsList == "MAP") {
  //       window.cartedesannonces = mapRef;
  //     }
  //   }
  // }, [mapRef, mapVsList]);
  const currentListing = useSelector(
    ListingreducerSelectors.currentListingSelactor
  );

  const [sortDialogVisible, setSortDialogVisisble] = useState<boolean>(false);

  const [favLoading, setFavLoading] = useState([]);
  const [lisingIdForFavourites, setLisingIdForFavourites] =
    useState<string>("");

  const [isAuthDialogVisible, setAuthDialogVisible] = useState<boolean>(false);

  const listingsSearchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );

  const [markerCoordinates, setMarkerCoordinates] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [regionsData, setRegionsData] = useState([]);
  const router = useRouter();

  // const regionsData = Object.entries(regions);

  const listings: any = useSelector(ListingreducerSelectors.listingsSelector);
  const listingsLoading: any = useSelector(
    ListingreducerSelectors.loadingSelactor
  );

  const listingsRefreching: any = useSelector(
    ListingreducerSelectors.refreshingSelactor
  );
  const searchPayload: any = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  let totalListingsCount: any = useSelector(
    ListingreducerSelectors.totalListingsCountSelactor
  );
  const [newTotalListings, setTotaListings] = useState(totalListingsCount);
  useEffect(() => {
    setTotaListings(totalListingsCount);
  }, [totalListingsCount]);

  const listingsRefreshing: any = useSelector(
    ListingreducerSelectors.refreshingSelactor
  );
  // const listingsFromMap = useSelector(ListingreducerSelectors.fromMapSelactor);
  const favListings: any = useSelector(
    ListingreducerSelectors.favoriteListingsSelactor
  );

  const mapState: any = useSelector(ListingreducerSelectors.mapStateSelactor);
  const [preventZoomEndAction, setPreventZoomEndAction] = useState<boolean>(
    mapState.preventZoomEndAction
  );

  const userData = useSelector(AuthreducerSelectors.userSelector);

  let controllBy = searchPayload?.controlBy ?? "API";
  const [isMobile, setIsMobile] = useState(true);
  const [skipListingFetchFirstTime, setSkipListingFetchFirstTime] =
    useState<boolean>(true);

  const [skipListingChangeFirstTime, setSkipListingChangeFirstTime] =
    useState<boolean>(true);
  const [listingsList, setListingslist] = useState(listings);
  const [mapReady, setMapReady] = useState(false);
  const setMapStyleSatellite = () => {
    if (window.cartedesannonces) {
      let opacity = window.cartedesannonces.getPaintProperty(
        "satellite copy",
        "raster-opacity"
      );
      if (opacity[0]) {
        let zoomState = window.cartedesannonces.getZoom();
        if (zoomState >= 15) {
          window.cartedesannonces.setPaintProperty(
            "satellite copy",
            "raster-opacity",
            0
          );
        } else {
          window.cartedesannonces.setPaintProperty(
            "satellite copy",
            "raster-opacity",
            1
          );
        }
      } else {
        if (opacity === 1) {
          window.cartedesannonces.setPaintProperty(
            "satellite copy",
            "raster-opacity",
            0
          );
        } else {
          window.cartedesannonces.setPaintProperty(
            "satellite copy",
            "raster-opacity",
            1
          );
        }
      }
    }
  };
  const searchListings = async () => {
    dispatch(
      ListingreducerActions.searchListings({
        refreshing:
          listingsSearchPayload?.page && listingsSearchPayload?.page !== 0
            ? true
            : false,
      })
    );
    // dispatch(ListingreducerActions.setloading({ loading: true }));
    try {
      if (listingsSearchPayload.page == 0) {
        let cont = $("#scrollcontainerlistings");
        cont[0].scrollTop(0);
      }
    } catch (e) {}
    try {
      let bounds = listingsSearchPayload.bounds;
      if (!bounds) {
        bounds = {
          _sw: {
            lng: -20,
            lat: 22,
          },
          _ne: {
            lng: 0,
            lat: 37,
          },
        };
      }
      let res: any = { data: null };
      if (bounds) {
        res = await api_call_v2(
          undefined,
          "get",
          "annonces/map",
          {
            params: {
              swlat: bounds._sw.lat,
              swlng: bounds._sw.lng,
              nelat: bounds._ne.lat,
              nelng: bounds._ne.lng,
              price_cut: listingsSearchPayload.price_cut,
              region: listingsSearchPayload.region,
              province: listingsSearchPayload.province,
              commune: listingsSearchPayload.commune,
              transaction_type: listingsSearchPayload.transaction_type,
              sort: listingsSearchPayload.sort,
              type: JSON.stringify(listingsSearchPayload.type),
              typologie: JSON.stringify(listingsSearchPayload.typologie),
              prixmax: listingsSearchPayload.prixmax,
              prixmin: listingsSearchPayload.prixmin,
              surfacemax: isNaN(listingsSearchPayload.surfacemax)
                ? null
                : listingsSearchPayload.surfacemax,
              surfacemin: isNaN(listingsSearchPayload.surfacemin)
                ? 0
                : listingsSearchPayload.surfacemin,
              pageSize: PAGE_SIZE,
              page: listingsSearchPayload.page,
              exclusivite: listingsSearchPayload.exclusivite,
              virtual_tour: listingsSearchPayload.virtual_tour,
              vendu: listingsSearchPayload.vendu,
            },
          },
          "v3"
        );
      } else {
        res = await api_call_v2(undefined, "post", "annonces/list", {
          data: encrypt({ ...listingsSearchPayload, pageSize: PAGE_SIZE }),
        });
      }
      let decrypted = decrypt(res.data);
      dispatch(
        ListingreducerActions.searchListingSuccess({
          listings: decrypted.result ? decrypted.result : decrypted[0].results,
          totalListingsCount: decrypted.totalItems
            ? decrypted.totalItems
            : decrypted[0].count.total,
          refreshing:
            listingsSearchPayload.page && listingsSearchPayload.page !== 0,
        })
      );
      try {
        document.getElementById("scrollcontainerlistings").scrollTop = 0;
      } catch (e) {}
      try {
        document.getElementById("scroll-map").scrollTop = 0;
      } catch (e) {}

      // dispatch(ListingreducerActions.setloading({ loading: false }));
    } catch (e) {
      dispatch(
        ListingreducerActions.searchListingSuccess({
          listings: [],
          totalListingsCount: 0,
          refreshing: false,
        })
      );
      dispatch(ListingreducerActions.searchListingError({ error: e }));
      // dispatch(ListingreducerActions.setloading({ loading: false }));
    }
  };
  useEffect(() => {
    $("#scrollcontainerlistings").scroll(function () {
      var winScroll = $(this).scrollTop();
    });
  }, []);
  const onResultsFromMap = ({
    region,
    province,
    commune,
  }: {
    region?: string;
    province?: string;
    commune?: string;
  }) => {
    dispatch(
      ListingreducerActions.setCurrentLocationAddress({
        address: ``,
      })
    );
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          ...searchPayload,
          region,
          province,
          commune,
          quartier: [],
          page: 0,
          controlBy: "API",
          lat: null,
          lng: null,
          bounds: window.cartedesannonces.getBounds(),
        },
      })
    );
  };

  const onGeolocate = async (lat: number, lng: number, zoom?: number) => {
    if (zoom) {
      dispatch(
        ListingreducerActions.setSearchPayload({
          searchPayload: {
            lat,
            lng,
            controlBy: "MAP",
            sort: "date_desc",
            page: 0,
            zoom: zoom,
          },
        })
      );
    } else {
      dispatch(
        ListingreducerActions.setSearchPayload({
          searchPayload: {
            lat,
            lng,
            controlBy: "MAP",
            sort: "date_desc",
            page: 0,
          },
        })
      );
    }
  };

  const onListingPress: any = (
    listing: RootState["listingsV2"]["listings"][number]
  ) => {
    // dispatch(
    //   ListingreducerActions.setCurrentListing({ currentListing: listing })
    // );
    window.open(buildListingUrl(listing));
  };

  const onTransactionTypeChange = (item: {
    value: string;
    vendu: boolean;
    label: string;
    color: string;
  }) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          transaction_type: item.value,
          controlBy: listingsSearchPayload.controlBy,
          prixmax: searchPayload.prixmax,
          prixmin: searchPayload.prixmin,
          surfacemax: searchPayload.surfacemax,
          surfacemin: searchPayload.surfacemin,
          type: searchPayload.type,
          typologie: searchPayload.typologie,
          caracteristiques: searchPayload.caracteristiques,
          page: 0,
          exclusivite: false,
          virtual_tour: false,
          vendu: item.vendu,
        },
      })
    );
  };

  const onMapSearchParamsChange = (mapState) => {
    dispatch(ListingreducerActions.setMapState({ mapState }));
  };

  const onPriceRangeChange = ({
    minPrice,
    maxPrice,
  }: {
    minPrice?: any;
    maxPrice?: any;
  }) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          prixmax:
            typeof maxPrice == "string"
              ? parseInt(maxPrice.replaceAll(" ", ""))
              : maxPrice,
          prixmin:
            typeof minPrice == "string"
              ? parseInt(minPrice.replaceAll(" ", ""))
              : minPrice,
          page: 0,
        },
      })
    );
  };
  const onPlaceSearchResult = ({
    region,
    province,
    commune,
    quartier,
    lat,
    lng,
    shortName,
    adresse,
    zoom,
  }: {
    region?: string;
    province?: string;
    commune?: string;
    quartier?: any;
    lat?: any;
    lng?: any;
    shortName?: any;
    zoom?: any;
    adresse?: any;
  }) => {
    if (zoom > 13.9) {
      dispatch(
        ListingreducerActions.searchListings({
          refreshing: false,
        })
      );
    }
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          // no_trigger_search: zoom > 13.9 ? true : false,
          no_trigger_search: false,
          region,
          province,
          commune,
          quartier: quartier ? [quartier] : [],
          lat: lat && zoom >= ZOOM_TRANSITION_MAP_API ? lat : null,
          lng: lng && zoom >= ZOOM_TRANSITION_MAP_API ? lng : null,
          sort: "date_desc",
          controlBy: isMobile
            ? mapVsList === "LIST"
              ? "API"
              : "MAP"
            : (lat && zoom >= ZOOM_TRANSITION_MAP_API) || zoom > 14
            ? "MAP"
            : "API",
          adresse: adresse,
          shortName,
          page: 0,
        },
      })
    );
  };

  const onSurfaceRangeChange = ({
    minSurface,
    maxSurface,
    exclusivite,
    virtual_tour,
  }: {
    minSurface?: any;
    maxSurface?: any;
    exclusivite?: any;
    virtual_tour?: any;
  }) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          surfacemax: parseInt(maxSurface),
          surfacemin: parseInt(minSurface),
          exclusivite: exclusivite,
          virtual_tour: virtual_tour,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          controlBy: listingsSearchPayload.controlBy
            ? listingsSearchPayload.controlBy
            : "API",
          shortName: null,
          page: 0,
        },
      })
    );
  };
  const onMeubleeChange = (meublee: boolean) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          meublee: meublee,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          shortName: null,
          page: 0,
        },
      })
    );
  };
  const onTypologieSelect = (typologie: number[]) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          typologie,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          controlBy: listingsSearchPayload.controlBy,
          shortName: null,
          page: 0,
        },
      })
    );
  };

  const onTypesSelected = (types) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          type: types,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          controlBy: listingsSearchPayload.controlBy,
          shortName: null,
          page: 0,
        },
      })
    );
  };

  const onCaracteristicsSelect = (caracteristics) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          caracteristiques: caracteristics,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          shortName: null,
          page: 0,
        },
      })
    );
  };

  const onPlacesAutoCompleteGeolocatePress = () => {
    dispatch(ListingreducerActions.IncrementGeolocateRequestsCounter({}));
  };

  const getUserFavorites = () => {
    const FBIdToken = localStorage.FBIdToken;
    api_call_v2(undefined, "get", "getUserFavoris", {}, "cloud_functions", true)
      .then((res) => {
        dispatch(
          ListingreducerActions.setFavListing({ favListings: res.data.result })
        );
        setFavLoading([]);
      })
      .catch((err) => {});
  };

  const onFavoriteIconPress = (listingId: string) => {
    const FBIdToken = localStorage.FBIdToken;
    if (FBIdToken) {
      addDeleteFavourite(listingId, FBIdToken);
    } else {
      setLisingIdForFavourites(listingId);
      dispatch(ListingreducerActions.setDisplayMobileSearchBar(false));
      setAuthDialogVisible(true);
    }
  };

  const addDeleteFavourite = (listingId: string, token?: string) => {
    setFavLoading([...favLoading, listingId]);
    if (favListings.includes(listingId)) {
      api_call_v2(undefined, "post", "deleteFavoris", {
        listingId: listingId,
      })
        .then((res) => {
          dispatch(
            ListingreducerActions.setFavListing({
              favListings: favListings.filter((item) => item !== listingId),
            })
          );
          setFavLoading(favLoading.filter((item) => item !== listingId));
          setLisingIdForFavourites("");
        })
        .catch((err) => {
          setFavLoading(favLoading.filter((item) => item !== listingId));
          setLisingIdForFavourites("");
        })
        .finally(() => setLisingIdForFavourites(""));
    } else {
      api_call_v2(undefined, "post", "addFavoris", {
        listingId: listingId,
      })
        .then((res) => {
          dispatch(
            ListingreducerActions.setFavListing({
              favListings: [...favListings, listingId],
            })
          );
          setFavLoading(favLoading.filter((item) => item !== listingId));
        })
        .catch((err) => {
          setFavLoading(favLoading.filter((item) => item !== listingId));
        })
        .finally(() => setLisingIdForFavourites(""));
    }
  };

  const onBulkFiltersChange = ({
    types,
    caracteristics,
    typologies,
    minSurface,
    maxSurface,
    meublee,
    prixmin = listingsSearchPayload.prixmin,
    prixmax = listingsSearchPayload.prixmax,
  }) => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          caracteristiques: caracteristics,
          type: types,
          typologie: typologies,
          surfacemax: maxSurface,
          surfacemin: minSurface,
          meublee: meublee,
          prixmin: prixmin,
          prixmax: prixmax,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          shortName: null,
          page: 0,
        },
      })
    );
  };
  const handleZoomStart = (zoom) => {
    zoomStart.current = zoom;
  };

  const showPopup: any = useSelector(
    ListingsReducerSelectors.showPopupSelactor
  );

  const initListeners = (e) => {
    window.cartedesannonces = e.target;

    // window.cartedesannonces.once("data", (event) => {
    //   if (searchPayload?.province) {
    //     if (ProvinceCenters[searchPayload?.province]) {
    //       window.cartedesannonces.flyTo({
    //         center: [
    //           ProvinceCenters[searchPayload?.province][0],
    //           ProvinceCenters[searchPayload?.province][1],
    //         ],
    //         zoom: 11,
    //         speed: 3,
    //       });
    //     }
    //   } else {
    //     if (searchPayload?.region) {
    //       if (RegionCenters[searchPayload?.region]) {
    //         window.cartedesannonces.flyTo({
    //           center: [
    //             RegionCenters[searchPayload?.region][0],
    //             RegionCenters[searchPayload?.region][1],
    //           ],
    //           zoom: 7,
    //           speed: 1,
    //         });
    //       }
    //     }
    //   }
    // });

    window.cartedesannonces.on("click", (e) => {
      dispatch(ListingreducerActions.setShowPopup(0));
      onMapListingData(null);
    });

    //Hover on Region
    window.cartedesannonces.on("mousemove", "regions", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["regions", "regions_line"],
        }
      );
      if (features && features.length > 0) {
        setMousePopupContent(
          features[0].properties.Nom_Région_FR
            ? features[0].properties.Nom_Région_FR
            : ""
        );
        window.cartedesannonces.setPaintProperty("regions", "fill-color", [
          "match",
          ["get", "OBJECTID"],
          features[0].properties.OBJECTID,
          "#00B4FF",
          "white",
        ]);
        window.cartedesannonces.setPaintProperty("regions", "fill-opacity", [
          "match",
          ["get", "OBJECTID"],
          features[0].properties.OBJECTID,
          0.5,
          0,
        ]);
      } else {
        setMousePopupContent("");
      }
    });

    // hover out of region
    window.cartedesannonces.on("mouseleave", "regions", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["regions", "regions_line"],
        }
      );
      if (features && features.length > 0) {
        setMousePopupContent(
          features[0].properties.Nom_Région_FR
            ? features[0].properties.Nom_Région_FR
            : ""
        );
      } else {
        setMousePopupContent("");
      }
    });

    //Hover Out of Province
    window.cartedesannonces.on("mouseleave", "provinces", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["provinces", "provinces_line"],
        }
      );
      if (features && features.length > 0) {
        setMousePopupContent(
          features[0].properties.Nom_Province
            ? features[0].properties.Nom_Province
            : ""
        );
      } else {
        setMousePopupContent("");
      }
    });

    //Hover On Province
    window.cartedesannonces.on("mousemove", "provinces", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["provinces", "provinces_line"], // replace this with the name of the layer
        }
      );

      if (features && features.length > 0) {
        setMousePopupContent(
          features[0].properties.Nom_Province
            ? features[0].properties.Nom_Province
            : ""
        );
        window.cartedesannonces.setPaintProperty("provinces", "fill-color", [
          "match",
          ["get", "id"],
          features[0].properties.id,
          "#00B4FF",
          "white",
        ]);

        window.cartedesannonces.setPaintProperty("provinces", "fill-opacity", [
          "match",
          ["get", "id"],
          features[0].properties.id,
          0.5,
          0,
        ]);
      } else {
        setMousePopupContent("");
      }
    });

    // Mouse Out of Map Stroke
    window.cartedesannonces.on("mouseout", () => {
      $(document).bind("mousemove", function (e: any) {
        $("#mousefollower").css({
          left: `${e.pageX + 20}px`,
          top: `${e.pageY}px` + 60,
          display: "none",
        });
      });
    });

    //Mouse Entered a region
    window.cartedesannonces.on("mouseenter", "regions", (e) => {
      $(document).bind("mousemove", function (e: any) {
        $("#mousefollower").css({
          left: `${e.pageX + 20}px`,
          top: `${e.pageY}px` + 60,
          display: "block",
        });
      });
    });

    //Mouse Entered a province
    window.cartedesannonces.on("mouseenter", "provinces", (e) => {
      $(document).bind("mousemove", function (e: any) {
        $("#mousefollower").css({
          left: `${e.pageX + 20}px`,
          top: `${e.pageY}px` + 60,
          display: "block",
        });
      });
    });

    // window.cartedesannonces.on("click", "annonces-agenz (1)", (event) => {
    //   const features = window.cartedesannonces.queryRenderedFeatures(
    //     event.point,
    //     {
    //       layers:
    //         searchPayload.transaction_type === "Projets Neufs"
    //           ? ["annonces-agenz (1)"]
    //           : ["annonces-agenz (1)", "annonces-label"],
    //     }
    //   );
    //   if (features && features.length > 0) {
    //     const data = {
    //       listing: features[features.length - 1].properties,
    //       coordinates: {
    //         longitude: event.lngLat.lng,
    //         latitude: event.lngLat.lat,
    //       },
    //     };
    //     // onMapListingData(data);
    //     dispatch(
    //       ListingreducerActions.setMapListing({
    //         listing: features[features.length - 1].properties,
    //         coordinates: {
    //           latitude: event.lngLat.lat,
    //           longitude: event.lngLat.lng,
    //         },
    //       })
    //     );
    //   }
    // });

    window.cartedesannonces.on("click", "annonces_transparent", (event) => {
      const e = event as typeof event & {
        originalEvent: { toElement?: { tagName?: string } };
      };
      if (e.originalEvent?.toElement?.tagName === "CANVAS") {
        // onMapListingData(null);
        dispatch(
          ListingreducerActions.setMapListing({
            listing: null,
            coordinates: {
              latitude: 0,
              longitude: 0,
            },
          })
        );
      } else {
        const features = window.cartedesannonces.queryRenderedFeatures(
          event.point,
          {
            layers: ["annonces_transparent"],
          }
        );

        if (features && features.length > 0) {
          const data = {
            listing: features[features.length - 1].properties,
            coordinates: {
              longitude: event.lngLat.lng,
              latitude: event.lngLat.lat,
            },
          };
          // onMapListingData(data);
          dispatch(
            ListingreducerActions.setMapListing({
              listing: features[features.length - 1].properties,
              coordinates: {
                latitude: event.lngLat.lat,
                longitude: event.lngLat.lng,
              },
            })
          );
        }
      }
    });
    window.cartedesannonces.on("drag", (e) => {
      dispatch(ListingreducerActions.setShowPopup(0));
      onMapListingData(null);
    });
    window.cartedesannonces.on("click", "annonces-agenz (1)", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["annonces-agenz (1)", "annonces_transparent"],
        }
      );
      if (features && features.length > 0) {
        const data = {
          listing: features[0].properties,
          coordinates: {
            longitude: event.lngLat.lng,
            latitude: event.lngLat.lat,
          },
        };
        // onMapListingData(data);
        dispatch(
          ListingreducerActions.setMapListing({
            listing: features[0].properties,
            coordinates: {
              latitude: event.lngLat.lat,
              longitude: event.lngLat.lng,
            },
          })
        );
      }
    });
    window.cartedesannonces.on("click", "annonces_transparent", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["annonces-agenz (1)", "annonces_transparent"],
        }
      );
      if (features && features.length > 0) {
        const data = {
          listing: features[0].properties,
          coordinates: {
            longitude: event.lngLat.lng,
            latitude: event.lngLat.lat,
          },
        };
        // onMapListingData(data);
        dispatch(ListingreducerActions.setShowPopup(1));
        dispatch(
          ListingreducerActions.setMapListing({
            listing: features[0].properties,
            coordinates: {
              latitude: event.lngLat.lat,
              longitude: event.lngLat.lng,
            },
          })
        );

        dispatch(
          ListingreducerActions.setActiveListingId(features[0].properties._id)
        );

        // dispatch(
        //   ListingreducerActions.setSearchPayload({
        //     searchPayload: {
        //       bounds: {
        //         ...searchPayload.bounds,
        //         _ne: {
        //           lng: features[0].properties.lng,
        //           lat: features[0].properties.lat,
        //         },
        //       }
        //     },
        //   })
        //   );
      }
    });
    window.cartedesannonces.on("mousemove", "communes", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["communes", "communes_line"], // replace this with the name of the layer
        }
      );
      if (window.cartedesannonces.getZoom() < 12) {
        if (features && features.length > 0) {
          // setMousePopupContent(features[0].properties.commune);
          // window.cartedesannonces
          //
          //   .setPaintProperty("communes", "fill-color", [
          //     "match",
          //     ["get", "id_commune"],
          //     features[0].properties.id_commune,
          //     "#00B4FF",
          //     "white",
          //   ]);
          // window.cartedesannonces
          //
          //   .setPaintProperty("communes", "fill-opacity", [
          //     "match",
          //     ["get", "id_commune"],
          //     features[0].properties.id_commune,
          //     0.5,
          //     0,
          //   ]);
        } else {
          setMousePopupContent("");
        }
      }
    });
    window.cartedesannonces.on("mouseenter", "communes", (e) => {
      $(document).bind("mousemove", function (e: any) {
        $("#mousefollower").css({
          left: `${e.pageX + 20}px`,
          top: `${e.pageY}px` + 60,
          display: "block",
        });
      });
    });
    window.cartedesannonces.on("mouseleave", "communes", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["communes", "communes_line"],
        }
      );
      // if (features && features.length > 0) {
      //   setMousePopupContent(features[0].properties.nom_commun);
      // } else {
      //   setMousePopupContent("");
      // }
    });

    window.cartedesannonces.on("click", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["regions", "regions_line"],
        }
      );

      if (features && features.length > 0) {
        if (
          features
            .map((item) => {
              return item.layer.id;
            })
            .includes("annonces_transparent") ||
          features
            .map((item) => {
              return item.layer.id;
            })
            .includes("annonces-agenz (1)") ||
          features
            .map((item) => {
              return item.layer.id;
            })
            .includes("annonces-label")
        ) {
        } else {
          window.cartedesannonces.flyTo({
            center: [event.lngLat.lng, event.lngLat.lat],
            zoom: 8.6,
            speed: 2.5,
          });
          onResultsFromMap({
            region: features[0].properties.Nom_Région_FR,
          });
        }
      }
    });

    window.cartedesannonces.on("click", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["provinces", "provinces_line"],
        }
      );

      if (features && features.length > 0) {
        if (
          features
            .map((item) => {
              return item.layer.id;
            })
            .includes("annonces_transparent") ||
          features
            .map((item) => {
              return item.layer.id;
            })
            .includes("annonces-agenz (1)") ||
          features
            .map((item) => {
              return item.layer.id;
            })
            .includes("annonces-label")
        ) {
        } else {
          window.cartedesannonces.flyTo({
            center: [event.lngLat.lng, event.lngLat.lat],
            zoom: 11.3,
            speed: 2.5,
          });
          onResultsFromMap({
            region: features[0].properties.region,
            province: features[0].properties.Nom_Province,
          });
        }
      }
    });

    window.cartedesannonces.on("click", (event) => {
      const features = window.cartedesannonces.queryRenderedFeatures(
        event.point,
        {
          layers: ["communes", "communes_line"],
        }
      );
      if (features && features.length > 0) {
        // setZoomEndFromCommune(true);
        onResultsFromMap({
          region: features[0].properties.region,
          province: features[0].properties.province,
          commune: features[0].properties.nom_commun,
        });

        window.cartedesannonces.flyTo({
          center: [event.lngLat.lng, event.lngLat.lat],
          zoom: 13,
          speed: 3.5,
        });
      }
    });

    window.cartedesannonces.on("dragend", (e) => {
      debounce_custom(handleDragEnd, 500);
    });
    switch_map_language(window.cartedesannonces, lang);

    window.cartedesannonces.on("zoomstart", () => {
      let zoom = window.cartedesannonces.getZoom();
      handleZoomStart(zoom);
      dispatch(ListingreducerActions.setShowPopup(0));
    });

    setMapReady(true);
  };

  const onMapListingData = (
    listingdata: null | {
      listing?: any;
      coordinates?: { latitude: number; longitude: number };
    }
  ) => {
    dispatch(ListingreducerActions.setMapListing({ mapListing: listingdata }));
  };
  const mapListing = useSelector(ListingreducerSelectors.mapListingSelactor);
  const activeListingId = useSelector(
    ListingreducerSelectors.activeListingIdSelactor
  );

  useEffect(() => {
    if (activeListingId && mapReady) {
      if (window.cartedesannonces?.setPaintProperty) {
        window.cartedesannonces?.setPaintProperty(
          "annonces-agenz (1)",
          "circle-color",
          [
            "match",
            ["get", "_id"],
            activeListingId,

            mapListing.listing
              ? "#1bb3bb"
              : searchPayload.transaction_type == "Vente"
              ? searchPayload.vendu
                ? "#00b4ff"
                : "#fc364a"
              : searchPayload.transaction_type == "Location"
              ? "hsl(53, 97%, 53%)"
              : "hsl(272, 75%, 42%)",

            searchPayload.transaction_type == "Vente"
              ? searchPayload.vendu
                ? "#00b4ff"
                : "#fc364a"
              : searchPayload.transaction_type == "Location"
              ? "hsl(53, 97%, 53%)"
              : "hsl(272, 75%, 42%)",
          ]
        );
      }
    }
  }, [activeListingId, mapReady, showPopup, searchPayload]);

  const onMapVsListChange = (mapVsList) => {
    setMapVsList(mapVsList);
    dispatch(ListingreducerActions.setMapListing({ mapListing: null }));
    dispatch(ListingreducerActions.setMAPVSLIST(mapVsList));
  };
  useEffect(() => {
    if (window.innerWidth < 990) {
      if (!mapVsList) {
        $("body").css("height", "100%");
        $("body").css("overflow", "hidden");
      } else {
        $("body").css("height", "auto");
        $("body").css("overflow", "scroll");
      }
    }
  }, [mapVsList]);

  const [mousePopupContent, setMousePopupContent] = useState<string>("");
  const [hideZoomInView, setHideZoomInView] = useState<boolean>(true);
  const allFilters = useSelector(ListingreducerSelectors.allFiltersSelactor);
  const { t, lang } = useTranslation("annonceAchat");
  const allFiltersFromMap = useSelector(
    ListingreducerSelectors.allFiltersFromMapSelactor
  );

  useEffect(() => {
    setMousePopupContent(t(mousePopupContent));
  }, [mousePopupContent]);

  const handleDragEnd = () => {
    // if (window.cartedesannonces.getZoom() > ZOOM_TRANSITION_MAP_API_DRAG) {
    //   dispatch(
    //     ListingreducerActions.setSearchPayload({
    //       searchPayload: {
    //         controlBy: "MAP",
    //         region: "",
    //         province: "",
    //         commune: "",
    //         sort: "date_desc",
    //         bounds: window.cartedesannonces.getBounds(),
    //         page: 0,
    //       },
    //     })
    //   );
    // } else {
    //   dispatch(
    //     ListingreducerActions.setSearchPayload({
    //       searchPayload: {
    //         controlBy: "API",
    //         bounds: window.cartedesannonces.getBounds(),
    //       },
    //     })
    //   );
    // }
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          controlBy: "MAP",
          region: "",
          province: "",
          commune: "",
          sort: "date_desc",
          bounds: window.cartedesannonces.getBounds(),
          zoom: window.cartedesannonces.getZoom(),
          page: 0,
        },
      })
    );
  };
  const openClosePopupOnZoomend = (zoomEnd) => {
    if (zoomEnd > ZOOM_TRANSITION_MAP_API) {
      setHideZoomInView(true);
    } else {
      setHideZoomInView(false);
    }
    if (zoomEnd >= MIN_ZOOM_TO_DISPLAY_POPUP && zoomEnd > zoomStart.current) {
      dispatch(ListingreducerActions.setShowPopup(1));
    } else {
      dispatch(ListingreducerActions.setShowPopup(0));
    }
  };
  const debouncedOpenClosePopup = useMemo(() => {
    return debounce(openClosePopupOnZoomend, 200);
  }, []);
  const handleZoomEnd = () => {
    let zoomEnd = window.cartedesannonces.getZoom();
    if (zoomEnd > ZOOM_TRANSITION_MAP_API) {
      if (
        searchPayload?.commune ||
        searchPayload?.province ||
        searchPayload?.region
      ) {
        if (searchPayload.no_trigger_search) {
          dispatch(
            ListingreducerActions.setSearchPayload({
              searchPayload: {
                no_trigger_search: false,
                bounds: window.cartedesannonces.getBounds(),
                zoom: zoomEnd,
              },
            })
            //Risque de déclencher maps deux fois
          );
        } else {
          dispatch(
            ListingreducerActions.setSearchPayload({
              searchPayload: {
                controlBy: "MAP",
                no_trigger_search: false,
                bounds: window.cartedesannonces.getBounds(),
                zoom: zoomEnd,
                sort: "date_desc",
                region: "",
                province: "",
                commune: "",
                page: 0,
              },
            })
          );
        }
      } else {
        let latlng = window.cartedesannonces.getCenter();
        dispatch(
          ListingreducerActions.setSearchPayload({
            searchPayload: {
              controlBy: "MAP",
              sort: "date_desc",
              region: "",
              province: "",
              commune: "",
              bounds: window.cartedesannonces.getBounds(),
              zoom: zoomEnd,
              lat: latlng.lat,
              lng: latlng.lng,
              page: 0,
            },
          })
        );
      }
    }
    debouncedOpenClosePopup(zoomEnd);
  };

  const onZooomButtonClick = () => {
    window.cartedesannonces.flyTo({
      center: [-7.619934703400256, 33.5712904838672],
      zoom: 13,
      speed: 2.5,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 990) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
        // onMapVsListChange("LIST");
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const zoomendListener = (e) => {
    handleZoomEnd();
  };
  useEffect(() => {
    if (mapVsList == "MAP") {
      if (window.cartedesannonces) {
        if (window.cartedesannonces.on) {
          window.cartedesannonces.on("zoomend", zoomendListener);
          return () => {
            if (window.cartedesannonces) {
              window.cartedesannonces.off("zoomend", zoomendListener);
            }
            return;
          };
        }
      }
    }
  }, [searchPayload, mapVsList]);

  let FiltersRef = useRef(allFilters);
  // const searchPayloadRef = useRef(listingsSearchPayload)
  let bounds: any = null;
  let boundsRef = useRef(bounds);
  const handleFiltersChanged = (allFilters) => {
    if (typeof window !== "undefined") {
      if (window.cartedesannonces) {
        if (allFilters) {
          if (window.cartedesannonces.getLayer) {
            try {
              if (window.cartedesannonces.getLayer("annonces-label")) {
                if (controllBy === "MAP") {
                  window.cartedesannonces.setFilter(
                    "annonces-label",
                    allFilters.filter((item) => {
                      return (
                        !item.includes("commune") && !item.includes("province")
                      );
                    })
                  );
                } else {
                  window.cartedesannonces.setFilter(
                    "annonces-label",
                    allFilters
                  );
                }
              }
            } catch (e) {}
            try {
              if (window.cartedesannonces.getLayer("annonces_transparent")) {
                if (controllBy === "MAP") {
                  window.cartedesannonces.setFilter(
                    "annonces_transparent",
                    allFilters.filter((item) => {
                      return (
                        !item.includes("commune") && !item.includes("province")
                      );
                    })
                  );
                } else {
                  window.cartedesannonces.setFilter(
                    "annonces_transparent",
                    allFilters
                  );
                }
              }
              if (window.cartedesannonces.getLayer("annonces-agenz (1)")) {
                if (controllBy === "MAP") {
                  window.cartedesannonces.setFilter(
                    "annonces-agenz (1)",
                    allFilters.filter((item) => {
                      return (
                        !item.includes("commune") && !item.includes("province")
                      );
                    })
                  );
                } else {
                  window.cartedesannonces.setFilter(
                    "annonces-agenz (1)",
                    allFilters
                  );
                }
              }
            } catch (e) {}
          }
        }
      }
    }
  };
  const firstUpdateFilters = useRef(true);

  useEffect(() => {
    if (firstUpdateFilters.current) {
      firstUpdateFilters.current = false;
      if (mapVsList == "MAP" && mapReady) {
        handleFiltersChanged([
          ...allFilters,
          ["==", "transaction_type", viewType],
        ]);
      }

      return;
    } else {
      if (mapVsList == "MAP" && mapReady) {
        if (allFilters) {
          handleFiltersChanged([
            ...allFilters,
            ["==", "transaction_type", viewType],
          ]);
        } else {
          handleFiltersChanged(["all", ["==", "transaction_type", viewType]]);
        }
      }
    }
  }, [allFilters, mapReady]);
  // removed controllBy idn this useEffect

  useEffect(() => {
    getUserFavorites();
  }, [userData]);
  const firstUpdate = useRef(true);

  const firstUpdateSP = useRef(true);
  const searchPayloadRef = useRef(listingsSearchPayload);

  useEffect(() => {
    // debounce_custom(() => {

    if (listingsSearchPayload.no_trigger_search) {
      return;
    }
    if (firstUpdateSP.current) {
      firstUpdateSP.current = false;

      return;
    } else if (
      JSON.stringify(searchPayloadRef.current) ==
      JSON.stringify(listingsSearchPayload)
    ) {
      return;
    } else {
      searchPayloadRef.current = listingsSearchPayload;
      if (listingsSearchPayload) {
        if (mapVsList == "MAP") {
          if (window.cartedesannonces) {
            if (window.cartedesannonces) {
              window.cartedesannonces.on("load", () => {
                window.cartedesannonces?.setPaintProperty(
                  "communes_line",
                  "line-width",
                  [
                    "match",
                    ["get", "commune"],
                    [
                      listingsSearchPayload.commune
                        ? listingsSearchPayload.commune
                        : "",
                    ],
                    3,
                    0,
                  ]
                );
              });
            }
          }
        }

        dispatch(ListingreducerActions.setMapAllFilters({ fromMap: true }));
        searchListings();

        // }
      }
    }
    // }, 0);
  }, [listingsSearchPayload]);
  //
  useEffect(() => {
    if (window.innerWidth < 990) {
      $("body").css("height", mapVsList == "MAP" ? "100%" : "auto");
    } else {
      $("body").css("height", "100%");
    }
  }, [mapVsList]);

  useEffect(() => {
    if (
      initialListings &&
      initialListings.length > 0 &&
      skipListingChangeFirstTime
    ) {
      setSkipListingChangeFirstTime(false);
    } else {
      setListingslist(listings);
    }
  }, [listings]);

  useEffect(() => {
    if (mapVsList == "MAP") {
      if (searchPayload.lat && searchPayload.lng) {
        if (window.cartedesannonces) {
          window.cartedesannonces.flyTo({
            center: [
              Math.min(searchPayload.lng, searchPayload.lat),
              Math.max(searchPayload.lng, searchPayload.lat),
            ],
            zoom: searchPayload.zoom,
            speed: searchPayload.speed ? searchPayload : 3,
          });
        }
      }
    }
  }, [
    searchPayload.lat,
    searchPayload.lng,
    searchPayload.zoom,
    searchPayload.speed,
  ]);
  const [pagetitle, setPageTitle] = useState<string>(title);

  const t2 = useTranslation("villesprovincescommunes").t;

  const titlePrefix = (
    t,
    transaction_type: "Vente" | "Location" | "Projets Neufs" | "",
    bienType: (
      | "Appartement"
      | "Villa"
      | "Terrain"
      | "Commerce"
      | "Bureau"
      | "Maison"
      | "Villas"
      | "Appartements"
      | "Lots de terrains"
      | "Riad"
      | "Local Industriel"
      | string
    )[],
    vendu: boolean
  ) => {
    switch (transaction_type) {
      case "Vente":
        return bienType.length === 1
          ? `${/*t(pluralOf(bienType[0]))*/ ""} ${
              vendu ? t("vendu") : t("à vendre")
            }`
          : vendu
          ? t("vendu")
          : t("à vendre");
      case "Location":
        return bienType.length === 1
          ? `${/*t(pluralOf(bienType[0]).replace("Local", "Locaux"))*/ ""} ${t(
              "à louer"
            )}`
          : t("à louer");

      case "Projets Neufs":
        return t("de projets neufs");
      default:
        return t("");
    }
  };

  const firstUpdateSPRef = useRef(true);
  const titleComplement: any = useSelector(
    ListingreducerSelectors.titleComplementSelector
  );
  useEffect(() => {
    setPageTitle(
      `${titlePrefix(
        t,
        searchPayload?.transaction_type ?? "",
        fix_type(searchPayload),
        searchPayload.vendu
      )} ${
        searchPayload.controlBy == "MAP"
          ? ""
          : titleSuffix(
              searchPayload?.region ?? "",
              searchPayload?.province ?? "",
              searchPayload?.address
                ? searchPayload?.address.split(",")[0]
                  ? searchPayload?.address.split(",")[0]
                  : searchPayload?.address
                : searchPayload?.commune ?? "",
              t,
              searchPayload?.quartier ?? [],
              titleComplement,
              searchPayload?.address ?? ""
            )
      }`
    );
  }, [searchPayload]);
  const [scrollY, setScrollY] = useState(0);

  const isAuthDialogVisibleTrigger = useSelector(
    UserSpaceSelectors.isAuthDialogVisibleSelector
  );
  useEffect(() => {
    if (isAuthDialogVisibleTrigger) {
      dispatch(ListingreducerActions.setDisplayMobileSearchBar(false));
      setAuthDialogVisible(true);
      dispatch(UserSpaceActions.setIsAuthDialogVisible({ data: false }));
    }
  }, [isAuthDialogVisibleTrigger]);
  const authenticatedRedux = useSelector(
    (store: any) => store?.auth?.authenticated
  );
  const userRedux = useSelector((store: any) => store?.auth?.user);
  const authenticatedProRedux = useSelector(
    (store: any) => store?.auth?.authenticatedPro
  );

  const [user, setUser] = useState(userRedux);
  useEffect(() => {
    setUser(userRedux);
  }, [userRedux]);
  const [activeRoute, setActiveRoute] = useState(router.pathname);

  // const [isAuthDialogVisible, setAuthDialogVisible] = useState(false);

  const getNavType = (pathname: string, authenticated: boolean) => {
    // /estimation/appartement/resultat?token=74bd70ea-f86b-4138-abf6-b5cb77ee2d65
    if (pathname.includes("user")) {
      return "NORMAL";
    } else if (pathname.includes("estimation")) {
      //on est dans l 'estimation
      if (!pathname.includes("estimation-")) {
        // on est pas dans la homePage d'estimation => on est dans estimation stepper
        if (pathname.includes("estimation") && pathname.includes("resultat")) {
          // on est dans les resultats
          if (!authenticated) {
            // resultat mais sans authentification

            return "ESTIMATION";
          } else {
            // authentifier => on affiche la navbar normale

            return "NORMAL";
          }
        } else {
          // on est dans estimation/map , estimation/bien ..

          return "ESTIMATION";
        }
      }
    }
    if (
      pathname.startsWith("/offres-pro") ||
      pathname.startsWith("/temoignages")
    ) {
      // on est dans une des pages de l'offre pro
      return "OFFRE_PRO";
    }
    if (
      pathname.startsWith("/espace-pro") ||
      pathname.startsWith("/espace-pro")
    ) {
      // on est dans espace pro => espace pro a son propre Navbar
      return "PRO_SPACE";
    }
    if (pathname.startsWith("/guide-du-credit")) {
      return "CREDIT";
    }
    if (pathname.startsWith("/credit")) {
      return "CREDIT";
    }
    return "NORMAL";
  };

  useEffect(() => {
    setActiveRoute(router.pathname);
  }, [router.pathname]);

  useEffect(() => {
    // if (JSON.stringify(userRedux) !== JSON.stringify(userUpdate.current)) {
    //   userUpdate.current = userRedux;
    checkUserClientSide(undefined, dispatch);
    // }
  }, []);

  const onLogout = () => {
    // dispatch(setAuthenticated({}));
    dispatch(updateUser({ data: null }));
    dispatch(signInR({ data: null }));
    dispatch(setUID({ data: null }));
    dispatch(setEmail({ data: null }));
    dispatch(setUserDispatch({ data: null }));
    localStorage.removeItem("FBIdToken");
    localStorage.removeItem("RT");
    nookies.set(undefined, "AccessToken", "", {
      path: "/",
    });
    nookies.destroy(undefined, "AccessToken");
    nookies.set(undefined, "FBIdToken", "", {
      path: "/",
    });
    nookies.destroy(undefined, "FBIdToken");
    nookies.set(undefined, "RT", "", {
      path: "/",
    });
    nookies.destroy(undefined, "RT");

    dispatch(setUserDispatch(null));
    dispatch(setAuthenticated(false));
  };

  const authenticated = authenticatedRedux || authenticatedProRedux;

  const navBarType = getNavType(activeRoute, authenticated);

  // const [checkListPath, setCheckListPath] = useState<boolean>(
  //   router.asPath.startsWith("/list.htm") ||
  //   router.asPath.startsWith("/map.htm")
  // );

  const parentDivRef = useRef<HTMLDivElement>(null);
  const listingSublist = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(false);
  const [fixAlert, setFixAlert] = useState(false);
  const [fixEnd, setFixEnd] = useState(false);

  const handleScroll = () => {
    if (parentDivRef.current) {
      const parentScrollTop = parentDivRef.current.scrollTop;
      setIsFixed(parentScrollTop >= 66);
    }

    if (parentDivRef.current) {
      const parentScrollTop = parentDivRef.current.scrollTop;

      const listingSublistTop =
        listingSublist.current?.getBoundingClientRect().top;

      // the scroll calcul without image

      // setFixAlert(parentScrollTop >= 299 && listingSublistTop > 307.5);
      // setFixEnd(parentScrollTop >= 299 && listingSublistTop <= 307.5);

      // the scroll calcul with image

      setFixAlert(parentScrollTop >= 299 && listingSublistTop > 708.5);
      setFixEnd(parentScrollTop >= 299 && listingSublistTop <= 708.5);
    }
  };

  const onAdressChange = (e) => {
    dispatch(ListingreducerActions.setSearchAdress(e));
  };

  const [exclusivity, setExclusivity] = useState(searchPayload.exclusivite);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const exclu = urlSearchParams.get("exclusivite");
    setExclusivity(exclu === "true" ? true : false);
  }, []);
  return (
    <>
      <ListingsRouterUrlHelper />
      {isAuthDialogVisible && (
        <Suspense fallback={<></>}>
          <LoginRegisterDialog
            visible={isAuthDialogVisible}
            bodyScrollonClose={true}
            onClose={() => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              setAuthDialogVisible(false);
            }}
            onFacebookSignInSuccess={(_, token) => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              setAuthDialogVisible(false);
              if (lisingIdForFavourites != "") {
                addDeleteFavourite(lisingIdForFavourites, `Bearer ${token}`);
              }
            }}
            onGoogleSignInSuccess={(_, token) => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              setAuthDialogVisible(false);
              if (lisingIdForFavourites != "") {
                addDeleteFavourite(lisingIdForFavourites, `Bearer ${token}`);
              }
            }}
            onRegisterSucccess={(_, token) => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              setAuthDialogVisible(false);
              if (lisingIdForFavourites != "") {
                addDeleteFavourite(lisingIdForFavourites, `Bearer ${token}`);
              }
            }}
            onSignInSuccess={(_, token) => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              setAuthDialogVisible(false);
              if (lisingIdForFavourites != "") {
                addDeleteFavourite(lisingIdForFavourites, `Bearer ${token}`);
              }
            }}
            onSwitchSignType={() => {
              return;
            }}
            Estimation={false}
          />
        </Suspense>
      )}
      <div className={ListingDiscoveryCss.mobileVisible}>
        {displayMobileSearchBar ? (
          <ListingsSortAndMapSwitch
            transaction_type={searchPayload?.transaction_type}
            mapVsList={mapVsList}
            onMapVsListChange={onMapVsListChange}
            setSortDialogVisisble={setSortDialogVisisble}
            onListingPress={onListingPress}
            listings={listings}
          />
        ) : null}
        <Suspense fallback={<></>}>
          <SortDialog
            sortDialogVisible={sortDialogVisible}
            setSortDialogVisisble={setSortDialogVisisble}
            sort={searchPayload?.sort ?? "price_asc"}
            onSortChange={(sort) => {
              dispatch(
                ListingreducerActions.setSearchPayload({
                  searchPayload: { sort: sort, page: 0 },
                })
              );
            }}
            transaction_type={searchPayload?.transaction_type}
          />
        </Suspense>
      </div>
      <div
        ref={parentDivRef}
        className={ListingDiscoveryCss.pageContainer}
        id="scrollcontainerlistings"
        style={
          mapVsList == "MAP"
            ? {
                paddingTop: "0px",
                overflow: "hidden !important",
                overflowY: "hidden",
              }
            : {
                paddingTop: "0px",
              }
        }
        onScroll={handleScroll}
      >
        {true ? (
          <>
            <div className={ListingDiscoveryCss.navbarDesktop}>
              <Navbar
                user={user}
                navBarType={navBarType}
                activeRoute={activeRoute}
                authenticated={authenticated}
                openAuthDialog={() => {
                  dispatch(
                    ListingreducerActions.setDisplayMobileSearchBar(false)
                  );
                  setAuthDialogVisible(true);
                }}
                onLogout={onLogout}
                position="relative"
                isNavBarList={true}
              />
            </div>
          </>
        ) : null}
        {mapVsList == "LIST" && displayMobileSearchBar ? (
          <div className={`${SearchBarStyle.item_desktop_hidden}`}>
            <SearchNavbar
              positionRelative={true}
              openAuthDialog={() => {
                dispatch(
                  ListingreducerActions.setDisplayMobileSearchBar(
                    isAuthDialogVisible
                  )
                );
                setAuthDialogVisible(!isAuthDialogVisible);
              }}
              onLogout={() => {
                return;
              }}
              component={
                <div
                  className={`
                    ${SearchBarStyle.autocomplete_input_navbar_container}`}
                >
                  <div
                    id="search-bar-input2"
                    className={`${SearchBarStyle.autocomplete_input_container} ${SearchBarStyle.positive_margin}`}
                  >
                    <PlacesAutoCompleteInput
                      lang={lang}
                      defaultAdress={searchPayload.address}
                      onAdressChange={onAdressChange}
                      onMapSearchParamsChange={onMapSearchParamsChange}
                      onPlaceSearchResult={onPlaceSearchResult}
                      onGeolocatePress={onPlacesAutoCompleteGeolocatePress}
                      showSearchInputField={true}
                      specialClassNames={"in_listings"}
                      onMapVsListChange={onMapVsListChange}
                    />
                  </div>
                </div>
              }
            />
          </div>
        ) : null}
        <div
          className={ListingDiscoveryCss.searchbarContainer}
          style={
            isFixed
              ? {
                  position: "fixed",
                  top: "0px",
                  background: "white",
                  zIndex: "200000",
                }
              : {}
          }
        >
          {true ? (
            <SearchbarComponent
              // checkListPath={true}
              transactionType={
                listingsSearchPayload?.transaction_type ?? viewType
              }
              onMapVsListChange={onMapVsListChange}
              onTransactionTypeChange={onTransactionTypeChange}
              onPlaceSearchResult={onPlaceSearchResult}
              onMapSearchParamsChange={onMapSearchParamsChange}
              onTypesSelected={onTypesSelected}
              onPriceRangeChange={onPriceRangeChange}
              onSurfaceRangeChange={onSurfaceRangeChange}
              onTypologieSelect={onTypologieSelect}
              onCaracteristicsSelect={onCaracteristicsSelect}
              onPlacesAutoCompleteGeolocatePress={
                onPlacesAutoCompleteGeolocatePress
              }
              onBulkFiltersChange={onBulkFiltersChange}
              onMeubleeChange={onMeubleeChange}
              totalListingsCount={totalListingsCount}
              openAuth={() => {
                dispatch(
                  ListingreducerActions.setDisplayMobileSearchBar(
                    isAuthDialogVisible
                  )
                );
                setAuthDialogVisible(!isAuthDialogVisible);
              }}
              scrollY={scrollY}
              mapVsList={mapVsList}
            />
          ) : null}
        </div>
        {mapVsList === "LIST" ? (
          <div
            className={ListingDiscoveryCss.mapAndListcontainer}
            style={isFixed ? { padding: "16px" } : { padding: "16px" }}
          >
            {!searchPayload.vendu ? (
              <FillDariane
                listingsSearchPayload={searchPayload}
                displayAnnonces={false}
              />
            ) : null}
            {isError ? null : (
              <ListingsPageTitle
                title={pagetitle}
                h1Type={h1Type}
                totalListingsCount={totalListingsCount}
              />
            )}
            <div className={ListingDiscoveryCss.annoncesContainer}>
              {exclusivity ? (
                userData ? (
                  userData.isPro ? (
                    <div className={ListingDiscoveryCss.ExcluMobile}>
                      <ExcluCard t={t} lang={lang} />
                    </div>
                  ) : null
                ) : null
              ) : null}

              <div className={ListingDiscoveryCss.titleMapAndListcontainer}>
                {isError ? (
                  <div className={ListingDiscoveryCss.listContainer}>
                    <div style={{ width: "100%" }}>
                      <ListingsResultAndSort
                        totalListingsCount={totalListingsCount}
                        map={mapVsList == "MAP"}
                      />
                    </div>
                    <Redirect404
                      transaction_type={searchPayload.transaction_type}
                    />
                  </div>
                ) : (
                  <>
                    {mapVsList ? (
                      <div className={ListingDiscoveryCss.listContainer}>
                        <ListingsListComponent
                          title={title}
                          h1Type={h1Type}
                          listings={listingsList}
                          favLoading={favLoading}
                          favListings={favListings}
                          listingsLoading={listingsLoading}
                          listingsRefreching={listingsRefreching}
                          onListingPress={onListingPress}
                          listingsSearchPayload={listingsSearchPayload}
                          onFavoriteIconPress={onFavoriteIconPress}
                          totalListingsCount={totalListingsCount}
                          mapVsList={mapVsList}
                          isAuthDialogVisible={isAuthDialogVisible}
                          setAuthDialogVisible={setAuthDialogVisible}
                        />

                        {!currentListing ? (
                          <>
                            <div
                              className={
                                ListingDiscoveryCss.pagination__container
                              }
                            >
                              <div className={ListingDiscoveryCss.pagesDesktop}>
                                <Pagination
                                  activePage={listingsSearchPayload.page}
                                  numberPages={
                                    parseInt(
                                      (
                                        totalListingsCount / PAGE_SIZE
                                      ).toString()
                                    ) ==
                                    totalListingsCount / PAGE_SIZE
                                      ? parseInt(
                                          (
                                            totalListingsCount / PAGE_SIZE
                                          ).toString()
                                        )
                                      : parseInt(
                                          (
                                            totalListingsCount / PAGE_SIZE
                                          ).toString()
                                        ) + 1
                                  }
                                  pagesToDisplay={10}
                                  onPageChange={(newPage) => {
                                    dispatch(
                                      ListingreducerActions.setPage(newPage)
                                    );
                                  }}
                                  noScriptLink={buildUrl(
                                    null,
                                    searchPayload,
                                    searchPayload,
                                    mapVsList,
                                    router.asPath.includes("annonces")
                                      ? mapVsList == "MAP"
                                        ? "map.htm"
                                        : "list.htm"
                                      : router.asPath
                                  )}
                                  rel={
                                    router.asPath.includes("annonces")
                                      ? "noindex, nofollow"
                                      : "noindex,follow"
                                  }
                                />
                                {/* {totalListingsCount}{" "} */}
                              </div>
                              {totalListingsCount > 20 ? (
                                <div
                                  className={ListingDiscoveryCss.pagesMobile}
                                >
                                  <Pagination
                                    activePage={listingsSearchPayload.page}
                                    numberPages={
                                      parseInt(
                                        (
                                          totalListingsCount / PAGE_SIZE
                                        ).toString()
                                      ) ==
                                      totalListingsCount / PAGE_SIZE
                                        ? parseInt(
                                            (
                                              totalListingsCount / PAGE_SIZE
                                            ).toString()
                                          )
                                        : parseInt(
                                            (
                                              totalListingsCount / PAGE_SIZE
                                            ).toString()
                                          ) + 1
                                    }
                                    pagesToDisplay={2}
                                    onPageChange={(newPage) => {
                                      dispatch(
                                        ListingreducerActions.setPage(newPage)
                                      );
                                    }}
                                    noScriptLink={buildUrl(
                                      null,
                                      searchPayload,
                                      searchPayload,
                                      mapVsList,
                                      router.asPath.includes("annonces")
                                        ? mapVsList == "MAP"
                                          ? "map.htm"
                                          : "list.htm"
                                        : router.asPath
                                    )}
                                    rel={
                                      router.asPath.includes("annonces")
                                        ? "noindex, nofollow"
                                        : "index,follow"
                                    }
                                  />
                                  {/* {totalListingsCount}{" "} */}
                                </div>
                              ) : null}
                            </div>
                          </>
                        ) : null}
                      </div>
                    ) : null}
                  </>
                )}
                <div className={ListingDiscoveryCss.side_bar__container}>
                  <SideBarAnnonce
                    userData={userData}
                    totalListingsCount={totalListingsCount}
                    displayMap={true}
                    fixAlert={fixAlert}
                    fixEnd={fixEnd}
                  />
                </div>
              </div>
            </div>
            {articleData && (
              <div ref={articleData ? listingSublist : null}>
                <ArticleInsideListingList articleData={articleData} />
              </div>
            )}
            <div ref={articleData ? null : listingSublist}>
              {/* <ListingsSubList
                quartier={
                  typeof searchPayload.quartier == "string"
                    ? searchPayload.quartier
                      ? searchPayload.quartier
                      : ""
                    : searchPayload.quartier
                      ? searchPayload.quartier[0]
                        ? searchPayload.quartier[0]
                        : ""
                      : ""
                }
                province={
                  searchPayload.province ? searchPayload.province : null
                }
                transaction_type={searchPayload.transaction_type}
                type={searchPayload.type[0]}
                currentListing={currentListing ? true : false}
              /> */}
            </div>

            {/* <FillDariane
              listingsSearchPayload={searchPayload}
              displayAnnonces={false}
            /> */}
            {sanityFooter ? (
              <>
                <div
                  className={`${ListingDiscoveryCss.footer} ${ListingDiscoveryCss.footerAnnonces}`}
                >
                  <div className={ListingDiscoveryCss.footerDesk}>
                    <Footer
                      propos={sanityFooter.propos[lang]}
                      proposText={
                        sanityFooter.text ? sanityFooter.text[lang] : ""
                      }
                      donnee={
                        sanityFooter.donnees ? sanityFooter.donnees[lang] : ""
                      }
                      donneeText={
                        sanityFooter.textdonnee
                          ? sanityFooter.textdonnee[lang]
                          : ""
                      }
                      technologie={
                        sanityFooter.technologie
                          ? sanityFooter.technologie[lang]
                          : ""
                      }
                      technologieText={
                        sanityFooter.texttechnologies
                          ? sanityFooter.texttechnologies[lang]
                          : ""
                      }
                      logo={
                        sanityFooter.agenz_logo
                          ? urlFor(sanityFooter.agenz_logo)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      facebook={
                        sanityFooter.facebook_logo
                          ? urlFor(sanityFooter.facebook_logo)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      instagram_logo={
                        sanityFooter.instagram_logo
                          ? urlFor(sanityFooter.instagram_logo)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      linked_in={
                        sanityFooter.linkedin_logo
                          ? urlFor(sanityFooter.linkedin_logo)
                              .format("webp")
                              .auto("format")
                              .fit("clip")
                              .auto("format")
                              .toString()
                          : null
                      }
                      socialMediaText={sanityFooter.socialMediatext}
                      copyRightText={sanityFooter.permission_text}
                    />
                  </div>
                </div>
              </>
            ) : null}
          </div>
        ) : null}
        {mapVsList == "MAP" ? (
          <div
            className={ListingDiscoveryCss.mapDivcontainer}
            // style={
            //   isFixed ? { padding: "105px 24px" } : { padding: "32px 24px" }
            // }
          >
            <div className={ListingDiscoveryCss.titleMapcontainer}>
              {mapVsList ? (
                <div
                  className={ListingDiscoveryCss.maplistContainer}
                  id="scroll-map"
                >
                  {!searchPayload.vendu ? (
                    <FillDariane
                      listingsSearchPayload={searchPayload}
                      displayAnnonces={false}
                    />
                  ) : null}
                  <div style={{ width: "100%" }}>
                    <ListingsPageTitle
                      title={pagetitle}
                      h1Type={h1Type}
                      totalListingsCount={totalListingsCount}
                    />
                  </div>
                  <ListingsListComponent
                    title={title}
                    h1Type={h1Type}
                    listings={listingsList}
                    favLoading={favLoading}
                    favListings={favListings}
                    listingsLoading={listingsLoading}
                    listingsRefreching={listingsRefreching}
                    onListingPress={onListingPress}
                    listingsSearchPayload={listingsSearchPayload}
                    onFavoriteIconPress={onFavoriteIconPress}
                    totalListingsCount={totalListingsCount}
                    mapVsList={mapVsList}
                  />
                  {!currentListing ? (
                    <>
                      <div
                        className={ListingDiscoveryCss.pagination__container}
                      >
                        <div className={ListingDiscoveryCss.pagesDesktop}>
                          <Pagination
                            activePage={listingsSearchPayload.page}
                            numberPages={
                              parseInt(
                                (totalListingsCount / PAGE_SIZE).toString()
                              ) ==
                              totalListingsCount / PAGE_SIZE
                                ? parseInt(
                                    (totalListingsCount / PAGE_SIZE).toString()
                                  )
                                : parseInt(
                                    (totalListingsCount / PAGE_SIZE).toString()
                                  ) + 1
                            }
                            pagesToDisplay={10}
                            onPageChange={(newPage) => {
                              dispatch(ListingreducerActions.setPage(newPage));
                            }}
                            noScriptLink={buildUrl(
                              null,
                              searchPayload,
                              searchPayload,
                              "LIST",
                              router.asPath.includes("annonces")
                                ? mapVsList == "MAP"
                                  ? "map.htm"
                                  : "list.htm"
                                : router.asPath
                            )}
                            rel={
                              router.asPath.includes("annonces")
                                ? "noindex, nofollow"
                                : "index,follow"
                            }
                          />
                          {/* {totalListingsCount}{" "} */}
                        </div>
                        <div className={ListingDiscoveryCss.pagesMobile}>
                          <Pagination
                            activePage={listingsSearchPayload.page}
                            numberPages={
                              parseInt(
                                (totalListingsCount / PAGE_SIZE).toString()
                              ) ==
                              totalListingsCount / PAGE_SIZE
                                ? parseInt(
                                    (totalListingsCount / PAGE_SIZE).toString()
                                  )
                                : parseInt(
                                    (totalListingsCount / PAGE_SIZE).toString()
                                  ) + 1
                            }
                            pagesToDisplay={2}
                            onPageChange={(newPage) => {
                              dispatch(ListingreducerActions.setPage(newPage));
                            }}
                            noScriptLink={buildUrl(
                              null,
                              searchPayload,
                              searchPayload,
                              mapVsList,
                              router.asPath.includes("annonces")
                                ? mapVsList == "MAP"
                                  ? "map.htm"
                                  : "list.htm"
                                : router.asPath
                            )}
                            rel={
                              router.asPath.includes("annonces")
                                ? "noindex, nofollow"
                                : "index,follow"
                            }
                          />
                          {/* {totalListingsCount}{" "} */}
                        </div>
                      </div>
                    </>
                  ) : null}
                  <div className={ListingDiscoveryCss.side_bar__container}>
                    <SideBarAnnonce
                      userData={userData}
                      totalListingsCount={totalListingsCount}
                      displayMap={false}
                    />
                  </div>

                  <div>
                    <ListingsSubList
                      quartier={
                        typeof searchPayload.quartier == "string"
                          ? searchPayload.quartier
                            ? searchPayload.quartier
                            : ""
                          : searchPayload.quartier
                          ? searchPayload.quartier[0]
                            ? searchPayload.quartier[0]
                            : ""
                          : ""
                      }
                      province={
                        searchPayload.province ? searchPayload.province : null
                      }
                      transaction_type={searchPayload.transaction_type}
                      type={searchPayload.type[0]}
                      currentListing={currentListing ? true : false}
                    />
                  </div>
                  {/* <FillDariane
                    listingsSearchPayload={searchPayload}
                    displayAnnonces={false}
                  /> */}
                  {sanityFooter ? (
                    <>
                      <div
                        className={`${ListingDiscoveryCss.footer} ${ListingDiscoveryCss.footerAnnonces}`}
                      >
                        <div className={ListingDiscoveryCss.footerDesk}>
                          <Footer
                            propos={sanityFooter.propos[lang]}
                            proposText={
                              sanityFooter.text ? sanityFooter.text[lang] : ""
                            }
                            donnee={
                              sanityFooter.donnees
                                ? sanityFooter.donnees[lang]
                                : ""
                            }
                            donneeText={
                              sanityFooter.textdonnee
                                ? sanityFooter.textdonnee[lang]
                                : ""
                            }
                            technologie={
                              sanityFooter.technologie
                                ? sanityFooter.technologie[lang]
                                : ""
                            }
                            technologieText={
                              sanityFooter.texttechnologies
                                ? sanityFooter.texttechnologies[lang]
                                : ""
                            }
                            logo={
                              sanityFooter.agenz_logo
                                ? urlFor(sanityFooter.agenz_logo)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()
                                : null
                            }
                            facebook={
                              sanityFooter.facebook_logo
                                ? urlFor(sanityFooter.facebook_logo)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()
                                : null
                            }
                            instagram_logo={
                              sanityFooter.instagram_logo
                                ? urlFor(sanityFooter.instagram_logo)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()
                                : null
                            }
                            linked_in={
                              sanityFooter.linkedin_logo
                                ? urlFor(sanityFooter.linkedin_logo)
                                    .format("webp")
                                    .auto("format")
                                    .fit("clip")
                                    .auto("format")
                                    .toString()
                                : null
                            }
                            socialMediaText={sanityFooter.socialMediatext}
                            copyRightText={sanityFooter.permission_text}
                          />
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              ) : null}
              <Suspense fallback={<></>}>
                <div className={ListingDiscoveryCss.mapContainer}>
                  {mapVsList == "MAP" ? (
                    <ListingsMapComponent
                      onLoad={(e) => {
                        initListeners(e);
                      }}
                      onStyleData={() => {
                        dispatch(
                          ListingreducerActions.setMapAllFilters({
                            fromMap: false,
                          })
                        );
                      }}
                      onGeolocate={onGeolocate}
                      setMapStyleSatellite={setMapStyleSatellite}
                      onListingPress={onListingPress}
                      ref={mapRef}
                      mousePopupContent={mousePopupContent}
                      setMousePopupContent={setMousePopupContent}
                      hideZoomInView={hideZoomInView}
                      markerCoordinates={markerCoordinates}
                      onZooomButtonClick={onZooomButtonClick}
                      viewType={viewType}
                      setAuthDialogVisible={setAuthDialogVisible}
                      // onLogout={onLogout}
                      openAuthDialog={() => {
                        dispatch(
                          ListingreducerActions.setDisplayMobileSearchBar(
                            isAuthDialogVisible
                          )
                        );
                        setAuthDialogVisible(!isAuthDialogVisible);
                      }}
                      onLogout={() => {
                        return;
                      }}
                    />
                  ) : null}
                </div>
              </Suspense>

              {/* {mapVsList == "LIST" ? (
                <div className={ListingDiscoveryCss.side_bar__container}>
                  <SideBarAnnonce
                  userData={userData}
                    totalListingsCount={totalListingsCount}
                  />
                </div>
              ) : (null)} */}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
